import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const SpreadsheetIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13 2C14.1046 2 15 2.89543 15 4V12C15 13.1046 14.1046 14 13 14H3C1.89543 14 1 13.1046 1 12V4C1 2.89543 1.89543 2 3 2H13ZM5.5 6L5.5 8.5H8.5L8.5 6H5.5ZM10 12.5H13C13.2761 12.5 13.5 12.2761 13.5 12V10H10V12.5ZM8.5 10V12.5H5.5V10H8.5ZM10 8.5H13.5V6H10L10 8.5ZM2.5 8.5H4V6H2.5V8.5ZM3 12.5H4L4 10H2.5V12C2.5 12.2761 2.72386 12.5 3 12.5Z"
			></path>
		</svg>
	),
)
